<template>
  <button
    class="primary button-icon button-icon-medium button--quick-shop"
    :class="{
      'active' : isFocus || (imageHoveringData?.productId === product?.id && imageHoveringData?.action === 'start'),
      'active-hover': isMouseOver,
    }"
    data-testid="quick-shop"
    :aria-label="`Open quick shop for ${product.detail.name} button`"
    @click="openSlideoutPQV(product)"
    @focus="toggleFocus"
    @blur="toggleFocus"
    @mouseover="mouseAction(true)"
    @mouseleave="mouseAction(false)"
  >
    <span class="label medium">Quick shop</span>
    <i class="icon accordion-plus-dark-medium" />
    <span class="long-bg" />
    <span class="short-bg" />
  </button>
</template>

<script setup>
/* istanbul ignore file */
import { ref } from 'vue';
import { useProductQuickviewSlideout } from '../../modules/sortable-grid/composables';

defineProps({
  product: {
    type: Object,
    default: () => {},
  },
});

const { openSlideoutPQV, imageHoveringData } = useProductQuickviewSlideout();

const isFocus = ref(false);
const isMouseOver = ref(false);
const toggleFocus = () => { isFocus.value = !isFocus.value; };
const mouseAction = (val) => { isMouseOver.value = val; };
</script>

<style lang="scss" scoped>
@import '~@core/csg/src/scss/encodedIcons/mcom/new/_accordion-plus-dark-medium.scss';

.button--quick-shop {
  align-items: center;
  border-radius: 32px;
  cursor: pointer;
  display: flex;
  justify-content: end;
  height: 32px;
  margin: 8px 8px 0 0;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: all 0 ease;
  z-index: 2;
  width: 110px;

  span.label, i {
    position: absolute;
    transition: all 0.2s ease;
    z-index: 2;
  }

  span.label {
    left: 7px;
    opacity: 0;
    width: 75px;
  }

  i {
    right: 4px;
  }

  .bg {
    background-color: $background-color;
    border-radius: 32px;
    height: 32px;
    position: relative;
    z-index: 1;
  }

  .short-bg {
    @extend .bg;
    width: 32px;
  }

  .long-bg {
    @extend .bg;
    display: none;
    width: 110px;
  }

  &.active {
    .short-bg {
      display: none;
    }

    .long-bg {
      display: block;
    }

    span.label {
      opacity: 1;
    }
  }

  // a work-around pure css :hover as it
  // flicker with other elements within.
  &.active-hover {
    .long-bg {
      background-color: $hover-color;
    }
  }
}

</style>

<style lang="scss" brand="bcom" scoped>
.button--quick-shop {
  i {
    opacity: 0.61; // = $gray-1-color = #6e6e6e
  }
}
</style>
